import L from "lodash/fp";
import inject from "scripts/ioc/inject";
// import {hmr} from 'scripts/utils/viewHelpers';
import { USE_LOCATION_FOR_ORG_AUTH } from "scripts/utils/securityHelpers";
import { pushFragment } from "scripts/utils/routerHelpers";
import Backbone from "backbone";
import BaseView from "scripts/views/baseView";
import ChangeOrganizationTileView from "scripts/views/changeOrganizationTileView";

import {
  geoLocationErrorAlert,
  noAdditionalLibrariesAlert,
  foundAdditionalLibrariesUsingLocation,
} from "scripts/alerts/alerts";

import styles from "sharedStyles/changeOrganization.css";
import template from "templates/changeOrganization.hbs";

// const hot = hmr(module, require);
const chan = Backbone.Radio.channel;

const createTile = L.curry((t, options) => new t(options));

class ChangeOrganizationView extends BaseView {
  constructor(
    options,
    deviceService = inject("deviceService"),
    securityService = inject("securityService"),
  ) {
    super(options);

    this.deviceService = deviceService;
    this.securityService = securityService;

    this.tileViews = [];

    const organization = this.securityService.getUser().getActiveOrganization();
    const { libraryCardUrl, name } = organization;

    this.state = {
      hasProfile: this.securityService.getUser().hasProfile(),
      showGeoLink: !USE_LOCATION_FOR_ORG_AUTH,
      activeOrganizationLibraryCardUrl: libraryCardUrl,
      activeOrganizationName: name,
    };

    this.template = () =>
      template({
        styles,
        ...this.state,
      });

    // hot('scripts/views/changeOrganizationTileView', c => this.renderTiles(c));
  }

  get events() {
    return {
      "click .target-manageLibrariesLink": "onClickManageLibraries",
      "click .target-geoLink": "onClickGeoLink",
      "click #bb-library-card-link": "onClickLibraryCardLink",
    };
  }

  className() {
    return styles.container;
  }

  render() {
    this.$el.html(this.template());

    this.renderTiles(ChangeOrganizationTileView);
  }

  renderTiles(tileClass) {
    this.closeSubViews(this.tileViews);

    const user = this.securityService.getUser();
    const activeOrganizationId = user.getActiveOrganizationId();
    const organizations = user.getOrganizations();

    this.tileViews = L.map(
      organization =>
        createTile(tileClass, {
          organization,
          isActive: organization.organizationId === activeOrganizationId,
        }),
      organizations,
    );

    this.tileViews.forEach(tileView => {
      this.addSubView(tileView)
        .appendTo(this.findTarget("cardRegion"))
        .render();

      tileView.on("click", options => {
        if (!options.isActive) {
          this.onChangeOrganization(options.organization.organizationId);
        }
      });
    });
  }

  onChangeOrganization(organizationId) {
    const user = this.securityService.getUser();

    user.setActiveOrganizationId(organizationId);

    this.securityService.setUser(user).then(() => {
      pushFragment("/home");
      chan("history").request("clear");
      chan("display").request("showFreshHomepage");
    });
  }

  onClickLibraryCardLink() {
    chan("tracking").trigger("libraryCard:click", {
      url: this.state.activeOrganizationLibraryCardUrl,
    });
  }

  onClickManageLibraries() {
    this.trigger("close");
  }

  onClickGeoLink() {
    chan("display").request("showBlockingLoader", 0);

    // this.state.showGeoLink = false;

    const user = this.securityService.getUser();

    this.securityService
      .fetchOrganizationUserUsingGeo()
      .then(geoUser => {
        const geoUserOrganizationIds = geoUser.getOrganizationIds();
        const currentOrganizationIds = user.getOrganizationIds();

        const newOrganizationIds = L.filter(
          L.complement(L.contains(L.__, currentOrganizationIds)),
          geoUserOrganizationIds,
        );

        if (newOrganizationIds.length > 0) {
          foundAdditionalLibrariesUsingLocation.show();

          geoUser.setActiveOrganizationId(user.getActiveOrganizationId());

          return this.securityService.setUser(geoUser);
        } else {
          return noAdditionalLibrariesAlert.show();
        }
      })
      .then(() => this.render())
      .catch(error => {
        console.log("Error fetching org user with geo: %O", error);
        return geoLocationErrorAlert(this.deviceService).show();
      })
      .finally(() => {
        chan("display").request("hideBlockingLoader");
      });
  }
}

export default ChangeOrganizationView;
